import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-input': {
      padding: 10.5,
    },
    '& .MuiInputLabel-outlined': {
      top: -8,
    },
    marginBottom: 20,
    width: 300,
  },
  titulo: {
    fontSize: 23,
    marginBottom: 20,
  }
});

export default function AcuseRecibo(props) {
  const { errorDestinoNotifica, onChangeNotificar } = props;
  const [destinoNotificacion, setDestinoNotificacion] = React.useState('');
  const [errorNotifica, setErrorNotifica] = React.useState('');
  const classes = useStyles();
  const { t } = useTranslation(['translation', 'pagos']);

  React.useEffect(() => {
    if (errorDestinoNotifica) {
      setErrorNotifica(errorDestinoNotifica);
    } else {
      setErrorNotifica('');
    }
  });

  const handleChange = (event) => {
    setDestinoNotificacion(event.target.value);
    onChangeNotificar(event.target.value);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" className={classes.titulo}>{t('pagos:comprotitulo')}</FormLabel>
      <Typography style={{textAlign: 'center'}} variant="subtitle1">({t('pagos:comprosubtitu')})</Typography>
        <div style={{textAlign: 'center', marginTop: '15px'}}>
        <TextField
          className={classes.root}
          error={errorNotifica !== ''}
          helperText={errorNotifica && errorNotifica !== '' ? t(errorNotifica) : t('pagos:ejemplofmt')}
          label={t('pagos:telefonocorreo')}
          value={destinoNotificacion}
          onChange={handleChange}
          variant="outlined"
        />
        </div>
    </FormControl>
  );
}
